import { render } from "./Drag.vue?vue&type=template&id=3e3fd2d6"
import script from "./Drag.vue?vue&type=script&lang=js"
export * from "./Drag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__